import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useState, useEffect, useRef, Children } from "react";
import Progress from "../Progress/Progress";
import ProgressCtx from "../../context/Progress";
import GlobalContext from "../../context/Global";
import StoriesContext from "../../context/Stories";
import { timestamp } from "../../utils/time";
var ProgressArray = function() {
    var ref = useState(0), count = ref[0], setCount = ref[1];
    var lastTime = useRef();
    var ref1 = useContext(ProgressCtx), currentId = ref1.currentId, next = ref1.next, videoDuration = ref1.videoDuration, pause = ref1.pause, bufferAction = ref1.bufferAction;
    var ref2 = useContext(GlobalContext), defaultInterval = ref2.defaultInterval, onStoryEnd = ref2.onStoryEnd, onStoryStart = ref2.onStoryStart, progressContainerStyles = ref2.progressContainerStyles;
    var stories = useContext(StoriesContext).stories;
    useEffect(function() {
        setCount(0);
    }, [
        currentId,
        stories
    ]);
    useEffect(function() {
        if (!pause) {
            animationFrameId.current = requestAnimationFrame(incrementCount);
            lastTime.current = timestamp();
        }
        return function() {
            cancelAnimationFrame(animationFrameId.current);
        };
    }, [
        currentId,
        pause
    ]);
    var animationFrameId = useRef();
    var countCopy = count;
    var incrementCount = function() {
        if (countCopy === 0) storyStartCallback();
        if (lastTime.current == undefined) lastTime.current = timestamp();
        var t = timestamp();
        var dt = t - lastTime.current;
        lastTime.current = t;
        setCount(function(countLocal) {
            var interval = getCurrentInterval();
            countCopy = countLocal + dt * 100 / interval;
            return countCopy;
        });
        if (countCopy < 100) {
            animationFrameId.current = requestAnimationFrame(incrementCount);
        } else {
            storyEndCallback();
            cancelAnimationFrame(animationFrameId.current);
            next();
        }
    };
    var storyStartCallback = function() {
        onStoryStart && onStoryStart(currentId, stories[currentId]);
    };
    var storyEndCallback = function() {
        onStoryEnd && onStoryEnd(currentId, stories[currentId]);
    };
    var getCurrentInterval = function() {
        if (stories[currentId].type === "video") return videoDuration;
        if (typeof stories[currentId].duration === "number") return stories[currentId].duration;
        return defaultInterval;
    };
    var opacityStyles = {
        opacity: pause && !bufferAction ? 0 : 1
    };
    return /*#__PURE__*/ _jsx("div", {
        style: _object_spread({}, styles.progressArr, progressContainerStyles, opacityStyles),
        children: Children.toArray(stories.map(function(_, i) {
            var active = 0;
            if (i === currentId) active = 1;
            else if (i < currentId) active = 2;
            return /*#__PURE__*/ _jsx(Progress, {
                count: count,
                width: 1 / stories.length,
                active: active
            });
        }))
    });
};
var styles = {
    progressArr: {
        display: "flex",
        justifyContent: "center",
        maxWidth: "100%",
        flexWrap: "nowrap",
        position: "absolute",
        width: "100%",
        padding: 5,
        paddingTop: 0,
        paddingLeft: 24,
        paddingRight: 24,
        alignSelf: "center",
        zIndex: 1001,
        // shadow
        // filter: 'drop-shadow(0 1px 8px #222)',
        transition: "opacity 400ms ease-in-out",
        top: 24
    }
};
export default ProgressArray;
